import { Controller } from "@hotwired/stimulus"

// Linhas aninhadas de um formulário (accepts_nested_attributes_for). A linha nova vem do
// <template>, com NOVO_ITEM trocado por um índice único; a linha já gravada não sai do DOM,
// só ganha `_destroy` e some, para o Rails apagá-la ao salvar.
//
// Com `precosUrl`, trocar o convênio, a data ou o exame de uma linha (e remover uma linha)
// busca os preços no servidor e redesenha o valor de cada linha e o total.
export default class extends Controller {
  static targets = ["lista", "modelo", "linha", "destruir", "exame", "valor", "convenio", "data", "total"]
  static values = { precosUrl: String }

  adicionar() {
    const html = this.modeloTarget.innerHTML.replace(/NOVO_ITEM/g, Date.now().toString())
    this.listaTarget.insertAdjacentHTML("beforeend", html)
    this.listaTarget.lastElementChild.querySelector("select")?.focus()
  }

  remover(evento) {
    const linha = evento.target.closest("[data-itens-target='linha']")
    const destruir = linha.querySelector("[data-itens-target='destruir']")
    const gravada = linha.querySelector("input[name$='[id]']")

    if (gravada) {
      destruir.value = "1"
      linha.hidden = true
    } else {
      linha.remove()
    }

    this.recalcular()
  }

  async recalcular() {
    if (!this.hasPrecosUrlValue || !this.hasTotalTarget) return

    const linhas = this.linhaTargets.filter((linha) => !linha.hidden)
    const params = new URLSearchParams()
    if (this.hasConvenioTarget) params.append("convenio_id", this.convenioTarget.value)
    if (this.hasDataTarget) params.append("data", this.dataTarget.value)
    for (const linha of linhas) {
      const exame = this.#exameDa(linha)
      if (exame) params.append("exame_ids[]", exame)
    }

    this.consulta?.abort()
    this.consulta = new AbortController()

    let precos
    try {
      const resposta = await fetch(`${this.precosUrlValue}?${params}`, {
        headers: { Accept: "application/json" },
        signal: this.consulta.signal,
      })
      if (!resposta.ok) return
      precos = await resposta.json()
    } catch (erro) {
      if (erro.name === "AbortError") return
      throw erro
    }

    for (const linha of linhas) {
      const celula = linha.querySelector("[data-itens-target='valor']")
      if (celula) celula.innerHTML = precos.valores[this.#exameDa(linha)] ?? ""
    }
    this.totalTarget.innerHTML = precos.total
  }

  #exameDa(linha) {
    return linha.querySelector("[data-itens-target='exame']")?.value
  }
}
